import { readInversionModel } from './inversion-read';
import { fromOriginAzimuth, applyGeoRefToModel } from './georef';

/**
 * Bundled sample inversion models ("Load sample": 3D viewer Insert ribbon, map Inversion panel). The EarthImager 3D demo
 * (hill3d trial 2, inverted with its terrain file) ships in public/data/samples/earthimager3d/ with its raw .stg survey.
 */
export const HILL3D_SAMPLE = {
  id: 'hill3d',
  file: 'hill3d_trial2_terrain.out',
  path: 'data/samples/earthimager3d/hill3d_trial2_terrain.out',
  name: 'hill3d demo (EarthImager 3D)',
  // The demo has no real-world position: put it at a fixed UTM 14N point (x east, y north).
  origin: [621000, 3349000],
  crs: 'EPSG:32614',
  azimuth: 90,
};

/** EarthImager 2D demo AGI56DD trial 3 (all iterations), placed on the AGI office DEM: 55 m line running north. */
export const AGI56DD_SAMPLE = {
  id: 'agi56dd',
  file: 'AGI56DD_trial3.out',
  path: 'data/samples/earthimager2d/AGI56DD_trial3.out',
  name: 'EarthImager 2D demo (AGI56DD trial 3)',
  origin: [611403, 3366451],
  crs: 'EPSG:32614',
  azimuth: 0,
};

export const SAMPLES = { hill3d: HILL3D_SAMPLE, agi56dd: AGI56DD_SAMPLE };

/**
 * Fetch a demo .out, read it exactly like an imported file (readInversionModel: the same code
 * path as the Inversion panel's import), place it with a fixed georeference and return a browser-only
 * model entry (no backendId, `sample: true`) ready for the session store. Throws with a readable message.
 */
export async function loadSample(id, { fetchFn = (...a) => fetch(...a), read = readInversionModel, baseUrl = process.env.PUBLIC_URL || '' } = {}) {
  const sample = SAMPLES[id];
  if (!sample) throw new Error(`unknown sample "${id}"`);
  const res = await fetchFn(`${baseUrl}/${sample.path}`);
  if (!res.ok) throw new Error(`could not fetch the sample (HTTP ${res.status})`);
  const text = await res.text();
  const model = { ...(await read(text, sample.file)), name: sample.name };
  const georef = fromOriginAzimuth(sample.origin, sample.azimuth, sample.crs);
  const geo = applyGeoRefToModel(model, georef);
  return {
    id: `inv-sample-${sample.id}`,
    name: sample.name,
    sample: true,
    cells: geo.cells,
    line: geo.line,
    georef: geo.georef,
    footprint: geo.footprint,
    model: { ...model, electrodes: geo.electrodes, crs: geo.crs, georef: geo.georef },
  };
}

export const loadHill3dSample = (opts) => loadSample('hill3d', opts);
